/**
 * Текст AudioWorklet: мост между графом Web Audio и главным потоком.
 *
 * Квант worklet — обычно 128 сэмплов. Главный поток копит их в кадры
 * по 20 мс и гоняет через WebSocket. Обратный PCM кладём в очередь
 * и отдаём в выход, иначе в динамик и в LiveKit уйдёт тишина.
 */
export const NOISE_FILTER_WORKLET_NAME = 'nf-pcm-bridge'

export const NOISE_FILTER_WORKLET_SOURCE = `
class NfPcmBridge extends AudioWorkletProcessor {
  constructor() {
    super();
    this.outQueue = [];
    this.outOffset = 0;
    this.port.onmessage = (event) => {
      if (event.data && event.data.type === 'playback') {
        this.outQueue.push(new Float32Array(event.data.samples));
        let queued = 0;
        for (let i = 0; i < this.outQueue.length; i += 1) {
          queued += this.outQueue[i].length;
        }
        const maxSamples = Math.round(sampleRate * 0.12);
        while (queued > maxSamples && this.outQueue.length > 1) {
          queued -= this.outQueue.shift().length;
        }
      }
    };
  }

  process(inputs, outputs) {
    const input = inputs[0] && inputs[0][0];
    const output = outputs[0] && outputs[0][0];

    if (input && input.length) {
      const copy = new Float32Array(input.length);
      copy.set(input);
      this.port.postMessage({ type: 'capture', samples: copy.buffer }, [copy.buffer]);
    }

    if (output) {
      let written = 0;
      while (written < output.length && this.outQueue.length > 0) {
        const chunk = this.outQueue[0];
        const available = chunk.length - this.outOffset;
        const need = output.length - written;
        const take = available < need ? available : need;
        output.set(chunk.subarray(this.outOffset, this.outOffset + take), written);
        written += take;
        this.outOffset += take;
        if (this.outOffset >= chunk.length) {
          this.outQueue.shift();
          this.outOffset = 0;
        }
      }
      if (written < output.length) {
        output.fill(0, written);
      }
    }

    return true;
  }
}

registerProcessor('${NOISE_FILTER_WORKLET_NAME}', NfPcmBridge);
`
